import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles, Typography } from '@material-ui/core';
import PieChart from 'components/@common/Charts/PieChart';
import InlineTextPopover from 'components/@common/InlineTextPopover';
import { PrmCurriculumProgressReportResult } from 'types/schema-generated-types';
import ChartLayout from './ChartLayout';

type Props = {
  prmCurriculumProgressReport?: PrmCurriculumProgressReportResult;
};

const OverallProgressChart: React.FC<Props> = ({ prmCurriculumProgressReport }) => {
  const classes = useStyles();
  const { t } = useTranslation('ReportsHelpCommon');

  const overallProgressPercentage = prmCurriculumProgressReport?.overallProgressPercentage ?? 0;
  const calcOverallPercent = (overallProgressPercentage: number) => {
    return overallProgressPercentage ? Math.round(overallProgressPercentage) : 0;
  };

  return (
    <ChartLayout
      Left={
        <PieChart
          type="radialBar"
          series={[calcOverallPercent(overallProgressPercentage)]}
          height={250}
          options={{
            tooltip: {
              y: {
                formatter: (data: any) => `${data}%`,
                title: {
                  formatter: () => 'Overall Progress:'
                }
              }
            },
            stroke: {
              lineCap: 'round'
            },
            plotOptions: {
              radialBar: {
                dataLabels: {
                  name: {
                    fontSize: '22px'
                  },
                  value: {
                    fontSize: '40px',
                    offsetY: -10
                  },
                  total: {
                    show: true,
                    label: ''
                  }
                }
              }
            },
            colors: ['#338AC6']
          }}
        />
      }
      Right={
        <>
          <Typography className={classes.title}>
            <InlineTextPopover PopoverContentProps={{ description: t('prmSetAReporting') }}>
              Overall Curriculum Progress
            </InlineTextPopover>
          </Typography>
          <Typography variant="h3">{calcOverallPercent(overallProgressPercentage)}%</Typography>
        </>
      }
    />
  );
};

const useStyles = makeStyles(theme => ({
  title: { fontSize: 18 }
}));

export default OverallProgressChart;
